export class UserTypeNames {
  static    Corporate = 'Corporate';
  static    CareSetting = 'Care Setting';
}
